import React from "react";
import { useTranslation } from "react-i18next";
import { PartnerInline } from "./models";

interface Props {
  partner: PartnerInline;
}

const PartnersListItem = ({ partner: { title, image } }: Props) => {
  const { t } = useTranslation();

  return (
    <article className="partners-inline-item">
      <div className="partners-inline-item__images">
        {image.link ? (
          <a href={image.link} target="_blank" rel="noopener noreferrer">
            <img src={image.src} alt={image.title} width={image.width} />
          </a>
        ) : (
          <img src={image.src} alt={image.title} width={image.width} />
        )}
      </div>
    </article>
  );
};

export default PartnersListItem;
